module.exports = __webpack_public_path__ + "1e58db9037784014c92a0fb81b7600ca.png";